import _ from 'lodash'

const isFileLoading = (state) => _.get(state, 'loading')
const editorImage = (state) => _.get(state, 'image')
const errors = (state) => _.get(state, 'errors')

export default {
	isFileLoading,
	errors,
	editorImage,
}
